import { useEffect } from 'react'
import { ShoesState } from 'src/types'
import { getCtx } from 'src/util/canvas'
import { drawAtomsShoesRearSurfaceLeftFoot, drawAtomsShoesRearSurfaceRightFoot } from '../drawAtomsShoesRearSurface'

export const useDrawShoesRear = (id: string, state: ShoesState) => {
  useEffect(() => {
    const { ctx, canvasWidth } = getCtx(id)
    if (ctx === null) return
    if (state.baseModel.productNumber === '') return
    drawAtomsShoesRearSurfaceLeftFoot(ctx, state)
    drawAtomsShoesRearSurfaceRightFoot(ctx, state, canvasWidth)
  }, [id, state])
}
